export const API_URL = "https://lk-frpback.pharus-dev.ru/ws/restapi/v1/";
export const AUTH_URL = "https://lk-frpback.pharus-dev.ru/";
export const IS_DEV_MODE = false;
// Показывать форму авторизации по пути /DAIT (на проде отключена — редирект на главную)
export const IS_AUTH_FORM_ENABLED = true;
export const BUTGET_URL = "https://test-budget.frprf.ru/";
